import React from 'react';
import { Shield } from 'lucide-react';
import { Section } from './Shared';
export const Guarantee = () => <Section className="max-w-3xl" data-id="element-91">
    <div className="glass-panel rounded-3xl p-8 md:p-12 text-center border-brand-gold/40 relative overflow-hidden pt-[30px] pb-[30px]" data-id="element-92">
      <div className="absolute top-0 left-0 w-full h-full bg-brand-gold/5 pointer-events-none" data-id="element-93"></div>
      <Shield className="w-16 h-16 text-brand-gold mx-auto mb-6" data-id="element-94" />
      <h2 className="text-3xl font-serif font-bold mb-4" data-id="element-95">
        GARANTÍA 7 DÍAS — SIN PREGUNTAS
      </h2>
      <p className="text-lg text-brand-text/90 mb-6 leading-relaxed" data-id="element-96">
        Abrís los tomos. Los aplicás en tu proceso. Si en 7 días no es lo que
        esperabas: devolución del 100%
        <br data-id="element-97" />
        <span className="font-medium text-brand-gold mt-2 block" data-id="element-98">
          Sin formularios. Sin drama. Sin vueltas.
        </span>
      </p>
      <div className="inline-block bg-brand-surfaceLight px-4 py-2 rounded-full text-sm text-brand-text/80 border border-brand-text/10" data-id="element-99">
        Tasa de devoluciones: menos del 1%.
      </div>
    </div>
  </Section>;
export const Footer = () => <footer className="border-t border-brand-text/10 bg-brand-dark pt-16 pb-8 px-4 sm:px-6 lg:px-8 text-center mt-12 space-x-[8px] space-y-[16px]" data-id="element-100">
    <div className="max-w-4xl mx-auto space-x-[8px] space-y-[1px]" data-id="element-101">
      <div className="inline-flex items-center space-x-2 mb-6" data-id="element-102">
        <span className="text-2xl" data-id="element-103">🌟</span>
        <span className="font-serif font-bold tracking-wider text-brand-gold text-xl" data-id="element-104">
          LUMEN AKASHA™
        </span>
      </div>

      <p className="text-brand-text/80 max-w-2xl mx-auto mb-8 text-[14px]" data-id="element-105">
        El sistema de sanación emocional akáshica N°1 para mujeres que están
        listas para soltar lo viejo y construir su próxima etapa desde un lugar
        mas sano.
      </p>

      <div className="flex flex-col md:flex-row space-y-4 md:space-y-0 md:space-x-8 text-sm text-brand-text/60 mb-12 pt-[10px] pb-[10px] mt-[1px] ml-[8px] items-center justify-center" data-id="element-106">
        <a href="mailto:soportelumenakasha@gmail.com" className="hover:text-brand-gold transition-colors" data-id="element-107">
          📧 soportelumenakasha@gmail.com
        </a>
        <span className="hidden md:inline" data-id="element-108">•</span>
        <a href="https://www.lumenakasha.com" className="hover:text-brand-gold transition-colors" data-id="element-109">
          🌐 www.lumenakasha.com
        </a>
      </div>

      <div className="text-xs text-brand-text/40 mb-12 pt-[10px] pb-[10px]" data-id="element-110">
        © Lumen Akasha™ 2026 — Todos los derechos reservados. Prohibida la
        reproducción y redistribución sin autorización expresa.
      </div>

      <p className="text-xl md:text-2xl font-serif italic text-brand-gold/80" data-id="element-111">
        "El campo está limpio. Estoy lista. El próximo capítulo empieza ahora."
        🌟
      </p>
    </div>
  </footer>;